import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getCurrencyObj, updateCurrencyObj } from '../services/dollarCurrency'

export const getRatesAction = createAsyncThunk('packages/getRates', async () => {
  const res = await getCurrencyObj()
  return res[0]
})

export const setRatesAction = createAsyncThunk('packages/setRates', async ({ poalimRate, EURToUSD, BOIrate, GBPToUSD }) => {
  const dollarCurrencyObjectID = '271963cc-e16b-4bfa-bdcb-d24199914b0f'
  const res = await updateCurrencyObj(dollarCurrencyObjectID, {
    updatedAt: new Date().toISOString(),
    poalimRate,
    EURToUSD,
    GBPToUSD,
    BOIrate,
  })
  return res.data.data.response.Attributes
})

export const packageSlice = createSlice({
  name: 'packages',
  initialState: {
    userPackages: [],
    shippedPackages: null,
    unShippedPackages: null,
    draftPackages: [],
    isUniteMode: false,
    EURToUSD: 0,
    GBPToUSD: 0,
    poalimRate: 0,
    BOIrate: 0,
    ratesObjUpdatedAt: null,
    packageForPayment: null,
    packageForReceiptUpload: null,
    packageForReturn: null,
    packageForPackageDetails: null,
    packageForReturnLabelUpload: null,
  },
  reducers: {
    setIsUniteMode: (state, { payload }) => {
      state.isUniteMode = payload
    },
    setPackageForPayment: (state, { payload }) => {
      state.packageForPayment = payload
      localStorage.setItem('payment-page-package', JSON.stringify(payload))
    },
    setPackageForReceiptUpload: (state, { payload }) => {
      state.packageForReceiptUpload = payload
      localStorage.setItem('upload-page-package', JSON.stringify(payload))
    },
    setPackageForReturn: (state, { payload }) => {
      state.packageForReturn = payload
    },
    setPackageForPackageDetails: (state, { payload }) => {
      state.packageForPackageDetails = payload
    },
    setPackageForReturnLabelUpload: (state, { payload }) => {
      state.packageForReturnLabelUpload = payload
    },
  },
  extraReducers: builder => {
    builder.addCase(getRatesAction.fulfilled, (state, { payload }) => {
      state.EURToUSD = payload.EURToUSD
      state.GBPToUSD = payload.GBPToUSD
      state.poalimRate = payload.poalimRate
      state.BOIrate = payload.BOIrate
      state.ratesObjUpdatedAt = payload.updatedAt
    })
  },
})

export const {
  setIsUniteMode,
  setPackageForPayment,
  setPackageForReceiptUpload,
  setPackageForReturn,
  setPackageForPackageDetails,
  setPackageForReturnLabelUpload,
} = packageSlice.actions
export default packageSlice.reducer
